<div class="flex justify-between">
  <div class="flex flex-col gap-[7px]">
    <div class="flex items-center gap-[8px] text-2xl leading-[25px] text-black">
      <div class="font-bold">Period Close:</div>
      <div>{{ selectedMonth() }}</div>
    </div>
    <ng-select
      #selectedQuarterEl
      class="quarter-select select select__big mt-0 w-[250px]"
      [clearable]="false"
      [searchable]="false"
      [multiple]="false"
      [formControl]="selectedQuarter()"
      [items]="quarters()"
      bindValue="value"
      bindLabel="label"
    >
      <ng-template let-item="item" ng-option-tmp>
        <div (click)="selectQuarter($event, item.value)" class="option-wrapper text-sm">
          {{ item.label }}
        </div>
      </ng-template>
    </ng-select>
    @if (flags().showCloseSettingsLink) {
      <aux-button
        class="flex h-[28px] items-center"
        label="Close Settings"
        (clickEmit)="onCloseSettingsClick()"
        variant="hyperlink"
        classList="p-0 text-aux-blue"
      />
    }
  </div>

  @if (months().length) {
    <aux-expense-analytic-card [months]="months()" />
  }
</div>
